import '@babel/polyfill';
import React,{useReducer} from "react"
import ReactDOM from "react-dom"
import {Route,Switch,BrowserRouter as Router} from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap"

import ClientApp from "./compontents/ClientApp";
import AdminApp from "./compontents/AdminApp";
 


const App= (props)=>
    {
        let path=window.location.pathname;
        path=path.substr(0,path.lastIndexOf("/"));
        console.log("the path is"+path);
    

        return (
             
        <Router basename={path}>
            <Switch>
                <Route path="/public.html" exact={true} component={ClientApp} />
                <Route path="/admin" exact={true} component={AdminApp} />
            </Switch>
            </Router>
   
            );
    }


ReactDOM.render(<App/>,document.getElementById("root"));

